export default __webpack_public_path__ + "static/media/kettlebell.f379f10b.jpg";